import { Compact, CompactRow, FieldLabel, FieldSelect, FieldSelectMulti } from '@newageerp/v3.bundles.form-bundle'
import { useURequest } from '@newageerp/v3.bundles.hooks-bundle';
import React, { useEffect } from 'react'

type Props = {
    adSources: string[],
    setAdSources: (v: string[]) => void,
}

export default function AdSourceFilter(props: Props) {
    const t = (e: string) => e;
    
    const { adSources, setAdSources } = props;

    const [doReq, reqData] = useURequest<string>("/app/plugins/Reports/ReportsFilter/distintAdSources");

    useEffect(() => {
        doReq({})
    }, []);

    return (
        <Compact>
            <CompactRow
                label={<FieldLabel>{t('Ad source (L1)')}</FieldLabel>}
                control={
                    <FieldSelectMulti
                        value={adSources}
                        onChange={setAdSources}
                        options={[
                            ...reqData.data.data.map(s => {
                                return (
                                    {
                                        label: s,
                                        value: s,
                                    }
                                )
                            }),
                        ]}
                        asString={true}
                        allowSelectAll={true}
                    />
                }
            />
        </Compact>
    )
}
